import PropTypes from 'prop-types';
import React, { useContext } from 'react';

import { ScrollIndicator } from '@powdr/components';
import {
  CarouselControlPlacement, CarouselPaginationType,
  Components, ScreenType,
} from '@powdr/constants';
import { AppContext } from '@powdr/context';
import { useSeason, useWindowResize } from '@powdr/hooks';

import { HeroSlide } from './components';
import { StyledContentBlockHero, HeroCarousel } from './styles';

export const ContentBlockHero = ({
  isAutoRotate = true,
  componentSeason = null,
  slideOffsetDirection = null,
  slideOffsetAdjustment = null,
  isEnableMobileVideoAutoplay = false,
  isImageDictatesHeight = false,
  isL1HeroOverride = false,
  isAltCopyDisplay = false,
  screenHeightOverride = null,
  hideOnPlatform = null,
  scrollToName = null,
  relationships,
}) => {
  const { isMobile, fullHeaderHeight } = useContext(AppContext);
  const { checkSeasonality } = useSeason();
  const resize = useWindowResize();
  const { heroSlides = [] } = relationships || {};
  const showScrollButton = (screenHeightOverride >= 100 && !isImageDictatesHeight);

  const heroScroll = () => {
    window.scrollTo({
      behavior: 'smooth',
      top: resize.windowHeight - fullHeaderHeight,
    });
  };

  const handleHideHero = () => {
    if (hideOnPlatform) {
      if ((isMobile && hideOnPlatform === ScreenType.MOBILE)
        || (!isMobile && hideOnPlatform === ScreenType.DESKTOP)
      ) return true;
    }

    if (!checkSeasonality(componentSeason)) return true;

    if (isL1HeroOverride) return true;

    return false;
  };

  return (
    (!handleHideHero()) && (
      <StyledContentBlockHero
        id={scrollToName}
        heroHeight={screenHeightOverride}
        isImageDictatesHeight={isImageDictatesHeight}
      >
        <HeroCarousel
          $moveControlsUp={showScrollButton}
          controlSettings={{
            pagination: {
              placement: CarouselControlPlacement.ON_SLIDE,
              type: CarouselPaginationType.BULLETS,
              class: 'hero-pagination',
            },
          }}
          componentTheme={Components.CONTENT_BLOCK_HERO}
          isAutoRotate={isAutoRotate}
          type="hero"
        >
          {(heroSlides || []).filter((s) => s && !s.isHideSlide).map((slide) => (
            <HeroSlide
              key={`${slide?.id}`}
              slide={slide}
              slideOffsetDirection={slideOffsetDirection}
              slideOffsetAdjustment={slideOffsetAdjustment}
              screenHeightOverride={screenHeightOverride}
              isEnableMobileVideoAutoplay={isEnableMobileVideoAutoplay}
              isAltCopyDisplay={isAltCopyDisplay}
            />
          ))}
        </HeroCarousel>
        {(showScrollButton) && (
          <ScrollIndicator onClick={heroScroll} ariaLabel="Scroll to Content" />
        )}
      </StyledContentBlockHero>
    )
  );
};

ContentBlockHero.propTypes = {
  isAutoRotate: PropTypes.bool,
  componentSeason: PropTypes.string,
  slideOffsetDirection: PropTypes.string,
  slideOffsetAdjustment: PropTypes.number,
  isEnableMobileVideoAutoplay: PropTypes.bool,
  isImageDictatesHeight: PropTypes.bool,
  isL1HeroOverride: PropTypes.bool,
  screenHeightOverride: PropTypes.number,
  scrollToName: PropTypes.string,
  isAltCopyDisplay: PropTypes.bool,
  hideOnPlatform: PropTypes.string,
  relationships: PropTypes.shape().isRequired,
};
